import { WizardShell } from '../components/WizardShell';

type BookCallIntroStepProps = {
  onContinue: () => void;
};

/**
 * Text-only step between account creation and the scheduler, so the reason for the
 * call lands before a booking widget appears.
 */
export function BookCallIntroStep({ onContinue }: BookCallIntroStepProps) {
  return (
    <WizardShell
      title="Let's book a date"
      subtitle="We recommend a setup call with our team, so you can understand how to get the most out of Afternoon."
      onAction={onContinue}
      actionLabel="Choose a time"
    />
  );
}
